export default __webpack_public_path__ + "static/media/rolesDesignResearch.f6834fc3.svg";